export const wrapListsInParagraph = (htmlString: string) => {
  return htmlString.replace(/<li[^>]*>(.*?)(?=(<\/li>|<li|<ul|<ol|<p))/g, (match, $1) => {
    if (/^<li[^>]*>$/.test(match)) {
      return match
    }

    return `<li><p>${$1}</p>`
  })
}
